import { Field } from 'formik'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FormGroup, Input, Label } from 'reactstrap'
import { getPropObject } from '../configs/app-configs'

const BaseFormGroup = ({
  fieldName,
  errors,
  touched,
  messageId,
  type,
  disabled,
  isRequired = true
}) => {
  const onBlur = (e, form) => {
    form.handleBlur(e)
    let { value } = e.target
    value = value.trim()
    form.setFieldValue(fieldName, value)
  }

  return (
    <FormGroup className='form-label-group position-relative'>
      <FormattedMessage id={messageId}>
        {(msg) => (
          <React.Fragment>
            <Field name={fieldName}>
              {({ field, form }) => (
                <Input
                  className={`form-control ${
                    isRequired &&
                    getPropObject(errors, fieldName) &&
                    getPropObject(touched, fieldName) &&
                    'is-invalid'
                  }`}
                  {...field}
                  type={type}
                  disabled={disabled}
                  value={field.value}
                  placeholder={msg}
                  onBlur={(e) => onBlur(e, form)}
                />
              )}
            </Field>

            {isRequired &&
            getPropObject(errors, fieldName) &&
            getPropObject(touched, fieldName) ? (
              <div className='text-danger'>
                {getPropObject(errors, fieldName)}
              </div>
            ) : null}
            <Label>{msg}</Label>
          </React.Fragment>
        )}
      </FormattedMessage>
    </FormGroup>
  )
}

export default BaseFormGroup
